import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { ICON_NAME } from '../../../../constants/icon';
import IconButton from '../../common/IconButton.vue';
import SvgIcon from '../../common/SvgIcon.vue';
import { useBasicStore } from '../../../../stores/basic';
import { useRoomStore } from '../../../../stores/room';
import { storeToRefs } from 'pinia';
import TUIRoomCore, {ETUIRoomEvents, ETUIRoomRole} from '@/TUIRoom/tui-room-core';
import {USER_ROLE_STARTV} from "@/constants/localKeys";
import useMasterApplyControl from '../../../hooks/useMasterApplyControl';


export default /*#__PURE__*/_defineComponent({
  __name: 'MasterApplyControl',
  setup(__props) {

const basicStore = useBasicStore();
const roomStore = useRoomStore();
const { handleUserApply, denyAllUserApply } = useMasterApplyControl();
const { isMaster,screenProfile, showApplyUserList } = storeToRefs(basicStore);
const { applyToAnchorList } = storeToRefs(roomStore);
const masterApplyControlRef = ref<InstanceType<typeof IconButton>>();
const masterApplyListRef = ref();

const hasApplyToAnchorUser = computed(() => applyToAnchorList.value.length > 0);

//同意上麦
async  function  succAgreetowheat(userId:string){
  console.log("我点击了同意上麦 ---------------11111---")
 let tuiRoomResponse = await handleUserApply(userId, true, screenProfile);
}
//不同意上麦
async  function  notAgreetowheat(userId:string){
  console.log("我点击了不同意上麦 ---------------22222---")
  let tuiRoomResponse = await handleUserApply(userId, false,null);
}


function toggleApplySpeech() {
  if (isMaster.value) {
    basicStore.setShowApplyUserList(!showApplyUserList.value);
  }
};

function hideApplyList() {
  basicStore.setShowApplyUserList(false);
}

function handleDocumentClick(event: MouseEvent) {
  if (
    showApplyUserList.value
    && !masterApplyControlRef.value?.$el.contains(event.target)
    && !masterApplyListRef.value?.contains(event.target)
  ) {
    basicStore.setShowApplyUserList(false);
  }
}

onMounted(() => {
  document.addEventListener('click', handleDocumentClick, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleDocumentClick, true);
});

return { __sfc: true,basicStore, roomStore, handleUserApply, denyAllUserApply, isMaster, screenProfile, showApplyUserList, applyToAnchorList, masterApplyControlRef, masterApplyListRef, hasApplyToAnchorUser, succAgreetowheat, notAgreetowheat, toggleApplySpeech, hideApplyList, handleDocumentClick, ICON_NAME, IconButton, SvgIcon }
}

})